var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharmacies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 19.7203H4.65884M8.44052 11.3752V14.4182M9.922 2.48836H8.32356C9.69397 1.34953 11.6374 1.27979 12.768 1.27979C15.9762 1.27979 19.2008 3.08224 19.2008 6.23105C19.2008 10.8324 15.1072 13.2486 11.2816 13.6385M5.67248 13.8724C4.82184 13.8724 4.11334 14.5533 4.11334 15.4C4.11334 16.9133 5.59451 16.9913 6.84208 16.9913C8.08964 16.9913 10.1559 16.6794 10.1559 16.6794M0.904375 7.1509C1.94496 9.45008 5.03506 11.1823 8.3974 11.1823C11.7466 11.1823 14.8354 9.46357 15.8916 7.17784C16.2571 6.38684 15.6862 5.45133 14.8149 5.45133H1.99303C1.13443 5.45133 0.55034 6.36867 0.904375 7.1509ZM9.86352 1.66965C9.63744 1.66965 9.45416 1.85292 9.45416 2.07901C9.45416 2.30509 9.63744 2.48836 9.86352 2.48836C10.0896 2.48836 10.2729 2.30509 10.2729 2.07901C10.2729 1.85292 10.0896 1.66965 9.86352 1.66965Z",
    stroke: "#1C587A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacies);
export default __webpack_public_path__ + "static/media/pharmacies.8d9cd86875402464c15b77d868ebca7d.svg";
export { ForwardRef as ReactComponent };